import { z } from 'zod';

import type { Booking } from '#domain/Booking.ts';
import { apiBooking } from '#store/apiBookingRoot.ts';

import { mapBooking } from './adapters/bookingAdapter.ts';
import { validateWarn } from './validateZodHelper.ts';

const bookingSchema = z
    .object({
        booking: z
            .enum(['NONE', 'ORDER_COM_RIO_FMS', 'ORDER_COM_THIRD_PARTY', 'CARTRIGHT_STANDARD', 'CARTRIGHT_ENTERPRISE'])
            .catch('NONE'),
        status: z.enum(['CONFIRMED', 'PENDING', 'DEACTIVATED']).catch('CONFIRMED'),
    })
    .passthrough();

export type ApiBooking = z.infer<typeof bookingSchema>;

const url = '/booking';
const TAG = 'BOOKING';

export const bookingApiSlice = apiBooking.injectEndpoints({
    endpoints: build => ({
        getBookingForAccount: build.query<Booking, void>({
            query: () => ({
                url,
            }),
            providesTags: [TAG],
            transformResponse: (response, meta, arg) => mapBooking(validateWarn(bookingSchema)(response, meta, arg)),
        }),
    }),
});

export const { useGetBookingForAccountQuery } = bookingApiSlice;
